import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      d: "m19.6 21.5-6.3-6.3q-.75.6-1.725.95T9.5 16.5q-2.725 0-4.612-1.887T3 10t1.888-4.612T9.5 3.5t4.613 1.888T16 10a6.1 6.1 0 0 1-1.3 3.8l6.3 6.3zm-10.1-7q1.875 0 3.188-1.312Q14 11.875 14 10t-1.312-3.187T9.5 5.5 6.313 6.813 5 10t1.313 3.188T9.5 14.5"
    }, null, -1)
  ])))
}
export default { render: render }